import { useEffect } from 'react';

import SettingsSubscriptionManager from '@features/settings-subscription/containers/SettingsSubscriptionManager';
import usePageTitle from '@hooks/usePageTitle/usePageTitle';
import { usePageContext } from '@providers/PageMetaProvider/model/PageContext';

const pageValues = {
  title: 'Subscription',
  description: 'Manage your subscription settings here',
};

function SettingsSubscriptionPage() {
  usePageTitle('ZlaytAI - My Subscription');
  const { setValues } = usePageContext();

  useEffect(() => {
    if (setValues) {
      setValues((prev) => ({
        ...prev,
        ...pageValues,
      }));
    }
  }, []);

  return <SettingsSubscriptionManager />;
}

export default SettingsSubscriptionPage;
